<template>
  <div>
    <div class="has-contents-centered">
      <figure class="image is-48x48">
        <img src="@/assets/mailbox.png">
      </figure>
    </div>
    <p>{{$t('login.weSentAn')}}</p>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('users', ['intercomUser'])
  }
}
</script>

<style lang="scss" scoped>
.title.is-4 {
  margin-bottom: 0;
}

div.has-contents-centered {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

p {
  line-height: 1.5;
}

</style>



// WEBPACK FOOTER //
// src/components/wallet/stack-confirm-link.vue